interface ChevronDownIconProps {
  className?: string;
  pathClassName?: string;
}

const ChevronDownIcon = ({ className = undefined, pathClassName = undefined }: ChevronDownIconProps) => (
  <svg
    className={className}
    width="14"
    height="9"
    viewBox="0 0 14 9"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      className={pathClassName}
      d="M0.645917 0.646894C0.692363 0.60033 0.747539 0.563387 0.808284 0.538181C0.869029 0.512974 0.93415 0.5 0.999917 0.5C1.06568 0.5 1.13081 0.512974 1.19155 0.538181C1.2523 0.563387 1.30747 0.60033 1.35392 0.646894L6.99992 6.29389L12.6459 0.646894C12.6924 0.600406 12.7476 0.563529 12.8083 0.53837C12.8691 0.513211 12.9342 0.500262 12.9999 0.500262C13.0657 0.500262 13.1308 0.513211 13.1915 0.53837C13.2522 0.563529 13.3074 0.600406 13.3539 0.646894C13.4004 0.693381 13.4373 0.748571 13.4624 0.80931C13.4876 0.870049 13.5005 0.93515 13.5005 1.00089C13.5005 1.06664 13.4876 1.13174 13.4624 1.19248C13.4373 1.25322 13.4004 1.30841 13.3539 1.35489L7.35392 7.35489C7.30747 7.40146 7.2523 7.4384 7.19155 7.46361C7.1308 7.48881 7.06568 7.50179 6.99992 7.50179C6.93415 7.50179 6.86903 7.48881 6.80828 7.46361C6.74754 7.4384 6.69236 7.40146 6.64592 7.35489L0.645917 1.35489C0.599354 1.30845 0.562411 1.25327 0.537205 1.19253C0.511998 1.13178 0.499023 1.06666 0.499023 1.00089C0.499023 0.935126 0.511998 0.870005 0.537205 0.80926C0.562411 0.748515 0.599354 0.693339 0.645917 0.646894Z"
    />
  </svg>
);

export default ChevronDownIcon;
